import React, {} from 'react'
import { IThread, IThreadOutput } from '../../../../graphql/types/queries/conversation'
import { IUser } from '../../../../graphql/types/queries/user'
import { Thread } from './Thread'
import { LineItem } from './LineItem'

interface IConversationProps {
  conversation: Array<IThreadOutput> | null, 
  session: IUser, 
  isPatientConvo: boolean
}

export const Conversations: React.FC<IConversationProps> = ({ conversation, session, isPatientConvo }) => {
  return (
    <>
      {conversation?.map(x => {
        return (<React.Fragment key={x.id}>
          {JSON.parse(JSON.stringify(x._embedded.threads))
            .reverse()
            .map((uu: IThread) => uu)
            .filter((x: IThread) => (x.state === 'published' || x.type === 'lineitem') && x.body !== 'initiate_1' && (x.type !== 'note' || (!x.body) || !x.body.startsWith('Set conversation status to')))
            .map((thread: IThread, i: number, arr: IThread[]) => {
              if (thread.type !== 'lineitem')
                return (<Thread isPatientConvo={isPatientConvo} session={session} thread={thread} key={thread.id} previousThread={i > 0 ? arr[i - 1] : null} nextThread={i < arr.length - 2 ? arr[i + 1] : null} />)
              if (thread.type === 'lineitem') {
                return (<LineItem isPatientConvo={isPatientConvo} thread={thread} key={thread.id} previousThread={i > 0 ? arr[i - 1] : null} />)
              }
            })}
        </React.Fragment>)
      })
      }
    </>
  )
}